import { FormattedMessage, useIntl } from "react-intl";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { FormMaskedTextBox, Alert } from "@mikros/shared-ui";
import { TextBoxProps } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import {
  Grid,
  GridColumn,
  GridNoRecords,
  GridPageChangeEvent,
  GridRowClickEvent,
} from "@progress/kendo-react-grid";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import ApiServices from "../../service/apiService";
import ErrorHandler from "../../utils/errorConfig";
import { Dialog } from "@progress/kendo-react-dialogs";

export function CustomerSearch() {
  const navigate = useNavigate();
  const errorInstance = ErrorHandler.getErrorInstance();
  const validators = {
    custNameValidator: (value: string) =>
      nameRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "shareCustomer.customerNameValidation",
          })}`,
    emailValidator: (value: string) =>
      value
        ? emailRegex.test(value)
          ? ""
          : `${intl.formatMessage({
              id: "shareCustomer.emailValidation",
            })}`
        : "",
    legalNameValidator: (value: string) =>
      legalNameRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "shareCustomer.leagalNameValidation",
          })}`,
    mobileNumberValidator: (value: string) =>
      value
        ? mobileRegex.test(value)
          ? ""
          : `${intl.formatMessage({
              id: "shareCustomer.mobileNumberValidation",
            })}`
        : "",
  };

  const nameRegex = new RegExp(/^$|[a-zA-Z\s. ]+$/);
  const emailRegex: RegExp = new RegExp(/^$|^.*@.*\..*$/);
  const legalNameRegex = new RegExp(/^$|[a-zA-Z\s. ]+$/);
  const mobileRegex: RegExp = new RegExp(/^$|[0-9]{5,15}$/);

  const [formKey, setFormKey] = React.useState(1);
  const [value, setValue] = React.useState<TextBoxProps["value"]>(" ");
  const [distChannel, setDistChannel] = React.useState<any>();
  const [searchClicked, setSearchClicked] = React.useState<boolean>(false);

  //error
  const [errorFlag, setErrorFlag] = React.useState<boolean>(false);

  console.log("dist channel print", distChannel);

  const email = distChannel?.map((dist: any) => dist.email);
  const emailEnabled = email?.map((email: any) => email.enabled);
  console.log("email channel", email);
  console.log("email enabled channel", emailEnabled);

  const slack = distChannel?.map((dist: any) => dist.slack);
  const slackEnabled = slack?.map((slack: any) => slack.enabled);
  console.log("slack  channel", slack);
  console.log("slack enabled channel", slackEnabled);

  const whatsapp = distChannel?.map((dist: any) => dist.whatsApp);
  const whatsappEnabled = whatsapp?.map((whatsapp: any) => whatsapp.enabled);
  console.log("whatsapp channel", whatsapp);
  console.log("whatsapp enabled channel", whatsappEnabled);

  const teams = distChannel?.map((dist: any) => dist.teams);
  const teamsEnabled = teams?.map((teams: any) => teams.enabled);
  console.log("teams channel", teams);
  console.log("teams enabled channel", teamsEnabled);

  async function searchCustomer(formData: { [name: string]: any }) {
    console.log("search customers screen", formData);
    const hasValidInput = Object.values(formData).some(
      (value) => typeof value === "string" && value.trim() !== ""
    );
    if (!hasValidInput) {
      console.log("No search fields filled. Skipping API call.");
      return; //  Skip API call if all fields are empty
    }

    setSearchClicked(true);

    let queryString = "";
    if (formData["mobileno"]) {
      if (queryString === "") {
        queryString = "phNo" + "=" + formData["mobileno"];
      } else {
        queryString = queryString + "&" + "phNo" + "=" + formData["mobileno"];
      }
    }
    if (formData["custName"]) {
      if (queryString === "") {
        queryString = "custName" + "=" + formData["custName"];
      } else {
        queryString =
          queryString + "&" + "custName" + "=" + formData["custName"];
      }
    }

    if (formData["legalName"]) {
      if (queryString === "") {
        queryString = "legalName" + "=" + formData["legalName"];
      } else {
        queryString =
          queryString + "&" + "legalName" + "=" + formData["legalName"];
      }
    }

    if (formData["email"]) {
      if (queryString === "") {
        queryString = "email" + "=" + formData["email"];
      } else {
        queryString = queryString + "&" + "email" + "=" + formData["email"];
      }
    }

    let api = ApiServices.getInstance();
    api
      .makeRequest(`organization/filteruser?${queryString}`, "GET")
      .then(async (data) => {
        if (data && data.errorMessage) {
          setErrorFlag(true);
          await errorInstance.updateErrorCode(data.errorMessage);
          return;
        }
        console.log("filter user customer data", data);
        setCustomerData(data);

        setPage((prev) => ({
          ...prev,
          take: data.length, // Show all rows
          skip: 0,
        }));
        setPageSizeValue("All");
      });
  }
  interface PageState {
    skip: number;
    take: number;
  }
  const initialDataState: PageState = { skip: 0, take: 10 };
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();
  const [customerData, setCustomerData] = React.useState<any>([]);

  console.log("print customer data in customer search", customerData);
  console.log("distb acc", customerData?.distbAcc);
  console.log("distribuiton channles print", distChannel);

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    //@ts-ignore
    const take =
      targetEvent.value === "All" ? customerData.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };
  const intl = useIntl();
  const distributionCell = (props: any) => {
    const { email, teams, slack, whatsApp } = props.dataItem.distbAcc;
    return (
      <td className="k-command-cell">
        <div className="w-full flex mt-2 space-x-2 justify-start items-center">
          {whatsApp.enabled && (
            <img
              src={require(`../../assests/images/whatsapp.png`)}
              width={15}
              height={15}
            />
          )}
          {teams.enabled && (
            //  &nbsp;
            <img
              src={require(`../../assests/images/teams.png`)}
              width={15}
              height={15}
            />
          )}
          {slack.enabled && (
            <img
              src={require(`../../assests/images/slack.png`)}
              width={15}
              height={15}
            />
          )}
          {email.enabled && (
            <img
              src={require(`../../assests/images/email.png`)}
              width={15}
              height={15}
            />
          )}
        </div>
      </td>
    );
  };

  React.useEffect(() => {
    let api = ApiServices.getInstance();
    api.makeRequest("organization", "GET").then(async (data) => {
      if (data && data.errorMessage) {
        setErrorFlag(true);
        await errorInstance.updateErrorCode(data.errorMessage);
        return;
      }
      console.log("print customer data in search customer", data);
      const distributionChannel = data?.map(
        (customerData: { distbAcc: any }) => customerData.distbAcc
      );
      const email = distributionChannel.map((channel: any) => channel.email);
      console.log("email", email);
      console.log("distribution channel inside Get", distributionChannel);
      setCustomerData(data);
      setDistChannel(distributionChannel);
    });
  }, []);

  const rowClick = (event: GridRowClickEvent) => {
    console.log(event);
    navigate("/createCustomer/" + event.dataItem.accntId);
  };

  const handleCreateCustomerClick = () => {
    navigate("/createCustomer/new");
  };

  const clearSearch = () => {
    setFormKey(formKey + 1);
    if (searchClicked) {
      let api = ApiServices.getInstance();
      api.makeRequest("organization", "GET").then(async (data) => {
        if (data && data.errorMessage) {
          setErrorFlag(true);
          await errorInstance.updateErrorCode(data.errorMessage);
          return;
        }
        console.log("clear customer search", data);
        setPage(initialDataState);
        setCustomerData(data);
      });
      setSearchClicked(false);
    }
  };

  return (
    <div className="">
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              navigate("/customer");
            }}
          />
        </Dialog>
      )}

      <div className="flex items-end justify-between">
        <div className="text-mk-primary-bright text-2xl font-semibold">
          <FormattedMessage id="searchCustomer.searchCustomer" />
        </div>

        <div className="flex mt-4 gap-4 ">
          <Button
            className="rounded bg-mk-primary-bright text-white hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2"
            onClick={handleCreateCustomerClick}
          >
            <FormattedMessage id="home.CreateCustomer" /> +
          </Button>
        </div>
      </div>

      <div className="mt-2">
        <Form
          onSubmit={searchCustomer}
          key={formKey}
          render={(formRenderProps) => (
            <FormElement>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Field
                    name={"custName"}
                    id={"custName"}
                    label={
                      <FormattedMessage id="searchCustomer.customerName" />
                    }
                    value={value}
                    component={FormMaskedTextBox}
                    validator={validators.custNameValidator}
                    onChange={(e: any) => {
                      const inputValue = e.value;
                    }}
                    className="bg-white w-96"
                    maxLength={20}
                  />
                </div>

                <div>
                  <Field
                    name={"email"}
                    id={"email"}
                    label={<FormattedMessage id="searchCustomer.EmailId" />}
                    maxLength={60}
                    component={FormMaskedTextBox}
                    className="bg-white w-96"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div>
                    <Field
                      name={"legalName"}
                      id={"legalName"}
                      label={<FormattedMessage id="searchCustomer.LegalName" />}
                      value={value}
                      validator={validators.legalNameValidator}
                      component={FormMaskedTextBox}
                      onChange={(e: any) => {
                        const inputValue = e.value;
                      }}
                      className="bg-white w-96"
                      maxLength={20}
                    />
                  </div>
                </div>
                <div>
                  <Field
                    name={"mobileno"}
                    id={"mobileno"}
                    label={
                      <FormattedMessage id="searchCustomer.MobileNumber" />
                    }
                    maxLength={20}
                    component={FormMaskedTextBox}
                    className="bg-white w-96"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div></div>
                <div className="mt-4">
                  <Button
                    className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
                                        hover:text-black focus:outline-none px-4 py-2"
                  >
                    <FormattedMessage id="searchCustomer.Search" />
                  </Button>
                  &nbsp;
                  <Button
                    className="rounded-lg bg-mk-light-grey text-black hover:bg-mk-light-grey

                                        hover:text-black focus:outline-none px-4 py-2"
                    onClick={clearSearch}
                  >
                    <FormattedMessage id="searchCustomer.Clear" />
                  </Button>
                </div>
              </div>
            </FormElement>
          )}
        />
      </div>

      <div className="mt-6 bg-transparent flex space-x-7 pb-8 px-4">
        <div className="text-mk-primary-bright">
          <Grid
            style={{ border: 0 }}
            rowHeight={48}
            data={customerData?.slice(page.skip, page.take + page.skip)}
            skip={page.skip}
            take={page.take}
            total={customerData.length}
            pageable={{
              buttonCount: 4,
              pageSizes: [5, 10, 15, "All"],
              pageSizeValue: pageSizeValue,
            }}
            onPageChange={pageChange}
            onRowClick={rowClick}
            className="cursor-pointer"
          >
            {/* Display when no records match */}
            <GridNoRecords>
              <div className="w-full h-full flex items-center justify-center text-center text-lg text-mk-primary-bright font-semibold mt-4">
                <FormattedMessage id="customer.noCustomer" />
              </div>
            </GridNoRecords>
            <GridColumn
              field="organizationName"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.customeGridName",
              })}
              headerClassName="custom-header"
              cell={(props) => <td>{props.dataItem?.organizationName}</td>}
            />
            <GridColumn
              field="legalName"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.LegalName",
              })}
              headerClassName="custom-header"
              cell={(props) => <td>{props.dataItem?.legalName}</td>}
            />
            <GridColumn
              field="email"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.EmailID",
              })}
              headerClassName="custom-header"
              cell={(props) => <td>{props.dataItem?.email}</td>}
            />
            <GridColumn
              field="phNo"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.MobileNumber",
              })}
              headerClassName="custom-header"
              cell={(props) => <td>{props.dataItem?.phNo}</td>}
            />
            <GridColumn
              field="status"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.Status",
              })}
              headerClassName="custom-header"
              cell={(props) => <td>{props.dataItem?.status}</td>}
            />
            <GridColumn
              field="level"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.Distribution",
              })}
              width={140}
              cell={distributionCell}
              headerClassName="custom-header"
            />
          </Grid>
        </div>
      </div>
      <div className="pb-[5%]"></div>
    </div>
  );
}
